module.exports = __webpack_public_path__ + "static/media/logo.0c34e1c1.png";